module.exports = __webpack_public_path__ + "static/kevin-rose-adae25759ab0773927d9395a12712861.jpg";